<script>
  import { onDestroy } from 'svelte';
  import InfiniteScroll from './InfiniteScroll.svelte';
  import FetchStateWrapper from './FetchStateWrapper.svelte';
  import ChevronUp from './ChevronUp.svelte';
  import ChevronDown from './ChevronDown.svelte';
  import Table from './Table.svelte';
  import Loader from '../Loader.svelte';
  import { searchKeyByValue } from 'components/Helper.js';

  export let columns;
  export let getData;
  export let scrollRef;
  export let multiSort = false;
  export let noResultMessage = 'No Results';
  export let datatableCallback = (state) => {};
  const FETCH_STATES = {
    idle: 'idle',
    pending: 'pending',
    success: 'success',
    error: 'error',
  };

  const SORT_ORDERS = {
    ASC: 'ASC',
    DESC: 'DESC',
  };

  let paginationState = { valueArray: [] };
  let fetchState = FETCH_STATES.idle;
  let paginationFetchState = FETCH_STATES.idle;
  let tableRef;
  let sortQueries = columns
    .filter((col) => col.sortable)
    .reduce((total, current) => {
      return { ...total, [current.key]: undefined };
    }, {});

  export function getDataTableState() {
    return {
      fetchState,
    };
  }

  export function getValues() {
    return paginationState.valueArray;
  }
  export function initializeState() {
    paginationState = { ...paginationState, valueArray: [] };
    fetchState = FETCH_STATES.idle;
    paginationFetchState = FETCH_STATES.idle;
    sortQueries = columns
      .filter((col) => col.sortable)
      .reduce((total, current) => {
        return { ...total, [current.key]: undefined };
      }, {});
  }

  let defaultSortQueries = {};
  export function setDefaultSort(sortKey, sortOrder) {
    defaultSortQueries[sortKey] = sortOrder;
  }
  export function setSortQuery(sortKey, sortOrder) {
    if (!multiSort) {
      // If multiSort is false, we nuke all queries on setting a new one
      Object.keys(sortQueries).forEach((key) => {
        sortQueries[key] = undefined;
      });
    }

    sortQueries[sortKey] = sortOrder;
  }

  function getSortQuery(sortKey) {
    return sortQueries[sortKey];
  }

  function withDeclaredQueries(queries) {
    return Object.entries(queries)
      .filter((entry) => entry[1] !== undefined)
      .reduce((total, current) => {
        return { ...total, [current[0]]: current[1] };
      }, {});
  }

  function toQueryParams(queries) {
    const sortBy = [];
    const sortOrder = [];
    Object.keys(queries).forEach((query) => {
      sortBy.push(query);
      sortOrder.push(queries[query]);
    });

    return {
      sortBy: sortBy.join(),
      sortOrder: sortOrder.join(),
    };
  }

  function fetchData() {
    if (getData === undefined) return;
    fetchState = FETCH_STATES.pending;
    setTimeout(() => {
      getData(toQueryParams(withDeclaredQueries(sortQueries)))
        .then((state) => {
          fetchState = FETCH_STATES.success;
          paginationState = state;
          datatableCallback(state);
        })
        .catch((err) => {
          fetchState = FETCH_STATES.error;
        });
    }, 100);
  }

  export const changeData = (row, key) => {
    var searchIndex = searchKeyByValue(paginationState.valueArray, key, row[key]);
    if (searchIndex !== -1) {
      var searchValue = paginationState.valueArray[searchIndex];
      paginationState.valueArray[searchIndex] = {
        ...searchValue,
        ...row,
      };
      for (var mainKey in paginationState.value) {
        var searchIndex = searchKeyByValue(paginationState.value[mainKey], key, row[key]);
        if (searchIndex !== -1) {
          paginationState.value[mainKey][searchIndex] = {
            ...searchValue,
            ...row,
          };
        }
      }
    }
  };

  $: {
    if (sortQueries) {
      fetchData();
    }
  }
</script>

<FetchStateWrapper
  data={paginationState.valueArray}
  noResultMessage={noResultMessage}
  state={fetchState}
>
  <div slot="success">
    <Table
      bind:this={tableRef}
      data={paginationState.valueArray}
      columns={columns}
      fixedHeader
      let:col
      let:row
    >
      <th
        slot="col"
        class="color-turquoise font-size-12 font-weight-600 border-0 {col.extraClass}"
        width={col.width || null}
      >
        {#if col.handleCheckbox != undefined}
          <div class="checkbox c-checkbox">
            <label>
              <input
                type="checkbox"
                name="live_bidding"
                on:change={col.handleCheckbox}
                value="1"
              />
              <span class="check-img"></span>
            </label>
          </div>
        {:else}
          <span
            class={col.sortable ? 'cursor' : ''}
            on:click={() => {
              if (col.sortable) {
                const sortQuery = getSortQuery(col.key);
                setSortQuery(
                  col.key,
                  sortQuery === undefined
                    ? SORT_ORDERS.ASC
                    : sortQuery === SORT_ORDERS.ASC
                      ? SORT_ORDERS.DESC
                      : SORT_ORDERS.ASC,
                );
              }
            }}
          >
            {col.label}
          </span>
          {#if col.sortable}
            <div class="sort-actions">
              {#if getSortQuery(col.key) === SORT_ORDERS.ASC || (paginationState.extraData.defaultSortBy && paginationState.extraData.defaultSortBy == col.key && paginationState.extraData.defaultSortOrder === SORT_ORDERS.ASC)}
                <ChevronUp active={true} />
              {/if}
              {#if getSortQuery(col.key) === SORT_ORDERS.DESC || (paginationState.extraData.defaultSortBy && paginationState.extraData.defaultSortBy == col.key && paginationState.extraData.defaultSortOrder === SORT_ORDERS.DESC)}
                <ChevronDown active={true} />
              {/if}

              <!-- <button
			  class="sort-button"
			  on:click={() => {
				setSortQuery(col.key, SORT_ORDERS.ASC);
			  }}>
			  <ChevronUp active={getSortQuery(col.key) === SORT_ORDERS.ASC} />
			</button>
			<button
			  class="sort-button"
			  on:click={() => {
				setSortQuery(col.key, SORT_ORDERS.DESC);
			  }}>
			  <ChevronDown
				active={getSortQuery(col.key) === SORT_ORDERS.DESC} />
			</button> -->
            </div>
          {/if}
        {/if}
      </th>

      <tr
        slot="row"
        class={row.className != undefined ? row.className : ''}
      >
        <slot row={row} />
      </tr>

      <InfiniteScroll
        elementScroll={scrollRef || tableRef}
        hasMore={paginationState.pageNumber < paginationState.totalPages}
        isLoading={paginationFetchState === FETCH_STATES.pending}
        on:loadMore={() => {
          if (paginationFetchState == FETCH_STATES.pending) {
            return false;
          }
          paginationFetchState = FETCH_STATES.pending;
          try {
            paginationState
              .nextPage()
              .then(({ state }) => {
                paginationFetchState = FETCH_STATES.success;
                paginationState = state;
                datatableCallback(state);
              })
              .catch(() => {
                paginationFetchState = FETCH_STATES.error;
              });
          } catch (err) {}
        }}
      >
        <tr>
          <td
            colspan={columns.length}
            class="text-center border-bottom-0"
          >
            <Loader />
          </td>
        </tr>
      </InfiniteScroll>
    </Table>
  </div>
</FetchStateWrapper>

<style lang="scss">
  .sort-actions {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
  }
  th {
    background: rgba(35, 46, 60, 0.024) !important;
    font-size: 0.625rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    line-height: 1.6;
    color: #656d77;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom-color: rgba(101, 109, 119, 0.16) !important;
  }
</style>
